import { render, staticRenderFns } from "./DialogUpdateStatus.vue?vue&type=template&id=6edbeaee"
import script from "./DialogUpdateStatus.vue?vue&type=script&lang=js"
export * from "./DialogUpdateStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports